import { Component, Input } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pet-rehome-success-modal',
  templateUrl: './pet-rehome-success-modal.component.html',
})
export class PetRehomeSuccessModalComponent {
  @Input('modalRef') public modalRef: NgbModalRef;

  constructor(
    private _router: Router
  ) {}

  public closeModal() {
    this.modalRef.close();
  }

  public onConfirm() {
    this.closeModal();
    this._router.navigate(['/dashboard']);
  }

}
